module.exports = __webpack_public_path__ + "img/baharain-3.d110bbc8.png";